import { useState, useEffect } from 'react';
import { apiKeyService, ApiKey } from '../services/apiKeyService';

export const useGoogleMapsApiKey = () => {
  const [apiKey, setApiKey] = useState<string | null>(null);
  const [apiKeyId, setApiKeyId] = useState<number | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchApiKey = async () => {
    try {
      setIsLoading(true);
      setError(null);

      const token = localStorage.getItem('accessToken');
      if (!token) {
        setApiKey(null);
        setApiKeyId(null);
        setIsLoading(false);
        return;
      }
      
      if (process.env.NODE_ENV !== 'production') {
        console.log('🔍 [useGoogleMapsApiKey] Début récupération clé API...');
        console.log('🔍 [useGoogleMapsApiKey] Token présent:', !!localStorage.getItem('accessToken'));
      }
      
      const apiKeys = await apiKeyService.getApiKeys();
      if (process.env.NODE_ENV !== 'production') {
        console.log('🔍 [useGoogleMapsApiKey] Clés API reçues:', apiKeys);
        console.log('🔍 [useGoogleMapsApiKey] Nombre de clés:', apiKeys.length);
      }
      
      const googleMapsKey = apiKeys.find((key: ApiKey) => {
        if (process.env.NODE_ENV !== 'production') {
          console.log('🔍 [useGoogleMapsApiKey] Analyse clé:', {
            id: key.id,
            name: key.name,
            provider: key.provider,
            service: key.service,
            isActive: key.isActive
          });
        }
        
        const isGoogleProvider = key.provider === 'google';
        const isMapService = key.service === 'maps' || 
                           key.service === 'Google Maps' || 
                           key.service.toLowerCase().includes('maps');
        
        if (process.env.NODE_ENV !== 'production') {
          console.log('🔍 [useGoogleMapsApiKey] Provider Google:', isGoogleProvider, 'Service Maps:', isMapService);
        }
        return isGoogleProvider && isMapService && key.isActive;
      });
      if (process.env.NODE_ENV !== 'production') {
        console.log('🗺️ [useGoogleMapsApiKey] Clé Google Maps trouvée:', googleMapsKey);
      }
      
      if (googleMapsKey) {
        setApiKey(googleMapsKey.keyValue);
        setApiKeyId(googleMapsKey.id);
        if (process.env.NODE_ENV !== 'production') {
          console.log('✅ [useGoogleMapsApiKey] Clé API configurée');
        }
      } else {
        setApiKey(null);
        setApiKeyId(null);
        if (process.env.NODE_ENV !== 'production') {
          console.log('❌ [useGoogleMapsApiKey] Aucune clé Google Maps trouvée');
        }
      }
    } catch (err) {
      console.error('❌ [useGoogleMapsApiKey] Erreur lors de la récupération:', err);
      setError('Impossible de récupérer la clé API Google Maps');
      setApiKey(null);
      setApiKeyId(null);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchApiKey();
  }, []);

  return {
    apiKey,
    apiKeyId,
    isLoading,
    error,
    hasApiKey: !!apiKey,
    refetch: fetchApiKey
  };
};
